<template>
  <b-card class="mb-5">
    <b-row>
      <b-col md="2">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="4">
        <b-row>
          <b-col></b-col>
          <b-col md="3">
            <label for="" class="labels text-info">Total Invoice:</label>
          </b-col>
          <b-col md="8">
         <h4> 
            {{ dataAccount.account.currency }} {{formatPrice(invoiceTotal)}}</h4>
          </b-col>
        </b-row>
        
      </b-col>
      <b-col md="5">
        <b-row>
          <b-col></b-col>
          <b-col md="3">
            <label for="" class="labels text-success">Total Payment :</label>
          </b-col>
          <b-col md="8">
         <h4> 
            {{ dataAccount.account.currency }} {{formatPrice(paymentTotal)}}</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col></b-col>
          <b-col md="3">
            <label for="" class="labels text-danger">Total Unpaid bill:</label>
          </b-col>
          <b-col md="8">
         <h4> 
            {{ dataAccount.account.currency }} {{formatPrice(unpaidBill)}}</h4>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="1 mt-4 float-right">
        <b-button variant="primary" class="float-right btn-custom" :to="'invoice/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
        <!-- <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel()" variant="info" class="mr-1 float-right btn-custom"><font-awesome-icon icon="download"/></b-button> -->
      </b-col>
    </b-row>
    <div class="border-bottom mb-3"></div>
    <form v-on:submit.prevent="doFilter">
      <b-row class="mt-3 mb-3">
        <b-col md="2 mt-2">
          <b-form-input
            customQueryParamName="search"
            v-model="tableFilter.search_customer"
            v-on:afterHit="doFilter"
            placeholder="Customer"
          />
        </b-col>
        <b-col md="2 mt-2">
          <!-- <b-form-select v-model="tableFilter.statusQuotation" :options="statusList" />  -->
          <b-form-select
            :options="statusList"
            customQueryParamName="search"
            v-on:afterHit="doFilter"
            v-model="tableFilter.statusInvoice"
            placeholder="Status"
          />
        </b-col>
        <b-col md="2 mt-2">
          <date-picker
            v-model="tableFilter.date"
            customQueryParamName="search"
            type="date"
            placeholder="Start Date"
          ></date-picker>
        </b-col>
        <b-col md="2 mt-2">
          <date-picker
            v-model="tableFilter.tanggal"
            type="date"
            customQueryParamName="search"
            placeholder="Due Date"
          ></date-picker>
        </b-col>
        <b-col md="4 mt-2">
          <!-- button filter -->
          <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
            <font-awesome-icon icon="search" />Filter
          </button>
          <!-- end button -->

          <!-- button clear filter -->
          <button
            @click="clearFilter()"
            class="ml-0 btn btn-outline-primary float-right"
            id="btn-search"
          >
            <font-awesome-icon icon="times-circle" /> Clear Filter
          </button>
          <!-- end button -->
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-3">
        <b-col md="4"> </b-col>
        <b-col md="4">
          <!-- <b-form-select v-model="tableFilter.order_type_id" :options="orderTypeList" />   -->
        </b-col>
      </b-row>
    </form>
    <b-row>
      <b-col md="12">
        <paginated-table
          ref="dataTable"
          :can-view="true"
          :can-reject="true"
          :can-edit="true"
          :data-url="apiUrl.invoice"
          :data-key="dataKey"
          :data-columns="columns"
          :data-params="['search_customer', 'start_date', 'due_date', 'status', 'search']"
        >
        </paginated-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PaginatedTable from '../../../components/PaginatedTable.vue';
export default {
  name: 'index-invoice',
  components: { PaginatedTable, DatePicker },
  data() {
    return {
      dataAccount: this.$store.getters['account/accountData'],
      dataKey: 'invoice',
      apiUrl: {
        invoice: window.AppConfig.apiUrl + 'invoice',
      },
      invoiceTotal: 0,
      paymentTotal: 0,
      unpaidBill: 0,
      tableFilter: {
        search_customer: this.$route.params.search_customer,
        start_date: this.$route.params.start_date,
        due_date: this.$route.params.due_date,
        status: this.$route.params.status,
        date: null,
        tanggal: null
      },
      columns: [
        {
          key: 'invoiceId',
          label: 'Invoice Number',
          sortable: true,
        },
        {
          key: 'invoiceStartDate',
          label: 'Invoice Date',
          sortable: true,
        },
        {
          key: 'customer',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'invoiceTotal',
          label: 'Invoice Total',
          sortable: true,
        },
        {
          key: 'invoicePaymentTotal',
          label: 'Payment Total',
          sortable: true,
        },
        {
          key: 'invoiceUnpaidBill',
          label: 'Unpaid Bill',
          sortable: true,
        },
        {
          key: 'statusInvoice',
          label: 'Status',
        },
        {
          key: 'actionInvoice',
          label: '',
          sortable: true,
        },
      ],
      statusList: [
        {
          value: null,
          text: 'Filter by status'
        },
        {
          value: 'CREATED',
          text: 'CREATED',
        },
        {
          value: 'CANCELED',
          text: 'CANCELED',
        },
        {
          value: 'PAID',
          text: 'PAID',
        },
        {
          value: 'UNPAID',
          text: 'UNPAID',
        },
      ],
    };
  },
  watch: {
    // 'tableFilter.search_customer'() {
    //   this.doFilter();
    // },

    'tableFilter.statusInvoice'() {
      this.doFilter();
    },   
  },
  methods: {


    doFilter() {
      // eslint-disable-next-line no-self-assign
      this.tableFilter.search_customer = this.tableFilter.search_customer;
      this.tableFilter.status = this.tableFilter.statusInvoice;
      this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date).format('YYYY-MM-DD') : null;
      this.tableFilter.due_date = this.tableFilter.tanggal !== null ? this.$moment(this.tableFilter.tanggal).format('YYYY-MM-DD') : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    clearFilter() {
      this.tableFilter.search_customer = null;
      this.tableFilter.statusInvoice = null;
      this.tableFilter.tanggal = null;
      this.tableFilter.date = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },



    // count total invoice
    getTotalInvoice() {
      this.$http.get(this.apiUrl.invoice).then((response) => {
        const { invoice } = response.data._embedded;
        invoice.forEach(inv => {
          this.invoiceTotal += inv.invoiceTotal;
          this.paymentTotal += inv.invoicePaymentTotal;
          this.unpaidBill += inv.invoiceUnpaidBill;
        })
        console.log(`invoice total is: ${this.invoiceTotal}`)
        console.log(`payment total is: ${this.paymentTotal}`)
        console.log(`unpaid bill total is: ${this.unpaidBill}`)
       
      }).catch(error=> {
        console.log('error', error);
      })
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // getValue(){
    //   let sum = 0;
    //   let numbers = this.
    // }
  },
  mounted() {
    this.getTotalInvoice();
  }
};
</script>
